import { isNil } from 'lodash';
import { useContext } from 'react';
import { MBImage } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBRemoveAttachmentButton } from '@shared/scenes/chat/input/components/attachment/row';
import { useResponsiveFormContext } from '@shared/scenes/entity/components/ResponsiveFormContext';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { useGoogleMapsImageUrl, useOpenMap } from './utils';

interface Props {
  lat: number;
  lon: number;
  width?: number;
  height?: number;
  iconUrl?: string;
  onClear?(): void;
}

export function GeolocationMapPreview({ lat, lon, iconUrl, width, height, onClear }: Props) {
  const responsiveForms = useResponsiveFormContext();
  const colors = useContext(ColorThemeContext);
  const openMap = useOpenMap(lat, lon);
  const googleMapsImageUrl = useGoogleMapsImageUrl({
    lat,
    lon,
    iconUrl,
    scale: responsiveForms ? 1 : 2,
    zoom: 15,
    size: responsiveForms ? '400x400' : '480x240',
  });

  return (
    <MBTouchableOpacity
      style={[
        {
          borderRadius: grid(1),
          borderTopRightRadius: responsiveForms ? 0 : grid(1),
          borderBottomRightRadius: responsiveForms ? 0 : grid(1),
          borderColor: responsiveForms ? Colors.v2.gray20 : Colors.v2.gray50_25,
          borderWidth: 1,
          overflow: 'hidden',
          margin: responsiveForms ? -1 : 0,
        },
      ]}
      onPress={openMap}
    >
      <MBImage
        source={{ uri: googleMapsImageUrl }}
        style={{
          width: width ?? '100%',
          height: height ?? grid(12),
          backgroundColor: colors.backgroundInactive,
          overflow: 'hidden',
        }}
      />
      {!isNil(onClear) && <MBRemoveAttachmentButton onPress={onClear} />}
    </MBTouchableOpacity>
  );
}
